import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Style layers first, and in this order.
//
// CSS is injected in module-evaluation order, so importing App above these
// would inject every component stylesheet *before* the base layer — and
// global.css rules like `.select { width: 100% }` would then override the
// per-screen widths that are meant to refine them.
import './styles/tokens.css'
import './styles/global.css'
import './styles/boot.css'

import { App } from './App'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
